import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class EventClassgroupRoute extends Route {
  @service eventData;

  model(params) {
    // classgroup_uuid is a UUID string
    const classGroupUuid = params.classgroup_uuid;
    // Get eventUuid from parent route
    const eventUuid = this.paramsFor('event').event_uuid;

    console.log(`[EventClassgroupRoute] Loading classgroup ${classGroupUuid} for event ${eventUuid}`);

    // Return UUIDs - the controller will compute derived values
    // This allows Ember's reactivity to properly track TrackedMap changes
    return {
      eventUuid,
      classGroupUuid
    };
  }
}
